module.exports = __webpack_public_path__ + "static/media/mobile-commit-title.19001e14.svg";